import { Component, inject, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { firstValueFrom } from 'rxjs';
import { WordExportService } from 'src/app/services/word-export.service';
import { HpDataProviderService } from 'src/app/services/hp-data-provider.service';
import { ItemService } from 'src/app/services/item.service';
import { StakeholderService } from 'src/app/services/stakeholder.service';
import { SpiderwebComponent } from "../../route-modules/spiderweb/spiderweb.component";
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-card-button-word-download',
    templateUrl: './card-button-word-download.component.html',
    styleUrls: ['./card-button-word-download.component.scss'],
    imports: [MatIcon, MatButton, SpiderwebComponent, SpiderwebComponent, MatProgressSpinner]
})
export class CardButtonWordDownloadComponent {
  @Input() number?: number;
  private wordExportService = inject(WordExportService);
  private hpProviderService = inject(HpDataProviderService);
  private stakeholderService = inject(StakeholderService);
  private itemService = inject(ItemService);
  
  public generating = false;

  public async onChartReady(ready: boolean) {
    if (ready) {
      await this.continueGeneratingWord();
    }
  }

  public generateWord(){
    this.generating = true;
    // Wait for the spiderweb to be loaded before generating the word document
    // SpiderwebComponent triggers onChartReady when the chart is ready
  }

  private async continueGeneratingWord() {
    try {
      const hp = this.hpProviderService.getHp(); 
      const items = await firstValueFrom(this.itemService.getItemsWithContentAsString());
      const stakeholders = await firstValueFrom(this.stakeholderService.getStakeholders());
      if(!hp) { 
        throw new Error('Hp is undefined'); 
      }
      await this.wordExportService.generateWordFromItems(hp, items, stakeholders)
    } finally {
      this.generating = false;
    }
  }
}
